import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { add } from '../../Store/Slices/user';
import { USER_PROFILE_GETTER } from '../../Utils/apis';
import useOnAuthFaild from '../useOnAuthFaild';

const useFetchProfile = () => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const onAuthFaild = useOnAuthFaild();

    useEffect(() => {

        (async () => {
            if (!loading) {
                try {
                    setLoading(true)
                    const res = await fetch(USER_PROFILE_GETTER, {
                        method: 'GET',
                        credentials: 'include',
                    });

                    if (res.ok) {
                        const user = await res.json();
                        dispatch(add(user.data));

                    }
                    else if (res.status === 401) {
                        onAuthFaild();
                    }
                    else {
                        const err = await res.json();
                        throw new Error(err.error);
                    }
                } catch (error) {
                    setError(error.message);
                }
                finally {
                    setLoading(false);
                }
            }
        })();

    }, []);

    return [loading, error];
}

export default useFetchProfile;